/*
 * Copyright (c) 2021 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Thursday, November 11th 2021, 10:55:26 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import FormLabel from "@mui/material/FormLabel";
import { CheckBoxSelector, CheckBoxSelectorProps } from "ui-widgets/select/CheckBoxSelector";
import { OSFormInputProps, useControlledInput } from "ui-widgets/forms";
import {
  APIFormInputErrorWrapper,
  CustomInputValidationErrorWrapper,
  HelperTextInputWrapper,
} from "ui-widgets/forms/FormInputWrappers";

type CheckBoxMultipleFormInputProps<T, TOption = any> = OSFormInputProps<T> &
  Omit<CheckBoxSelectorProps<TOption>, "values" | "onClickItem"> & {
    defaultValue?: TOption[];
  };

export const CheckBoxMultipleFormInput = <T, TOption = any>(props: CheckBoxMultipleFormInputProps<T, TOption>) => {
  const {
    field: { onChange, value = props.defaultValue ?? [] },
  } = useControlledInput<T>(props);

  const onCheckItem = (item: TOption) => {
    const itemValue = props.getOptionValue?.(item) ?? item;
    if ((value as any).includes(itemValue)) {
      onChange((value as any).filter((v) => v !== itemValue));
    } else {
      onChange([...(value as any), itemValue]);
    }
  };

  return (
    <APIFormInputErrorWrapper schema_field_key={props.schema_field_key} label={props.label}>
      <CustomInputValidationErrorWrapper {...props}>
        <HelperTextInputWrapper helperText={props.helperText}>
          {props.label && <FormLabel component="h4">{props.label}</FormLabel>}

          <CheckBoxSelector
            values={value as TOption[]}
            onClickItem={onCheckItem}
            options={props.options}
            getOptionLabel={props.getOptionLabel}
            getOptionValue={props.getOptionValue}
          />
        </HelperTextInputWrapper>
      </CustomInputValidationErrorWrapper>
    </APIFormInputErrorWrapper>
  );
};
